import React from 'react';
import classNames from 'classnames';

import { numberWithComma, decimalPlace2 } from 'src/utils/Utils';

import styles from './EmployeePayForm.scss';

const MoneyFieldMockup = ({ title, value, greenTextList }) => (
  <div className={classNames('m-table-obvious-inner', { [styles.textGreen]: greenTextList.includes(title) })}>{numberWithComma(decimalPlace2(value))}</div>
);

export default MoneyFieldMockup;
